// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Re3i","buttons":"styles_buttons__dbCKK"};